import React from 'react';
import { Box, Fab, Icon, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ChatTALI from './Components/ChatTALI';

const useStyles = makeStyles((theme) => ({
    '@keyframes taliPulse': {
        '0%': { boxShadow: `0 0 0 0 ${theme.palette.colors.violet[300]}66` },
        '70%': { boxShadow: `0 0 0 14px ${theme.palette.colors.violet[300]}00` },
        '100%': { boxShadow: `0 0 0 0 ${theme.palette.colors.violet[300]}00` },
    },
    root: {
        position: 'fixed',
        right: 20,
        top: '80%',
        transform: 'translateY(-50%)',
        width: 64,
        height: 64,
        zIndex: theme.zIndex.modal + 1,
        [theme.breakpoints.down('sm')]:{
          right: 15,
          top: '50%',
          transform: 'translateY(-50%)',
        },
    },
    icon: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        background: `linear-gradient(135deg, ${theme.palette.colors.violet[400]} 0%, ${theme.palette.colors.violet[300]} 100%)`,
        borderRadius: '50%',
        border: `2px solid ${theme.palette.colors.violet[200]}`,
        boxShadow: '0 6px 18px rgba(72, 47, 107, 0.45)',
        animation: '$taliPulse 2.8s infinite',
        transition: 'all 0.3s ease',
        '&:hover': {
            cursor: 'pointer',
            transform: 'scale(1.08)',
            background: `linear-gradient(135deg, ${theme.palette.colors.violet[500]} 0%, ${theme.palette.colors.violet[400]} 100%)`,
            boxShadow: '0 10px 28px rgba(72, 47, 107, 0.6)',
            animation: 'none',
        },
        '& .ri-robot-2-line, & .ri-cpu-line, & .ri-arrow-right-s-line': {
            fontSize: '30px',
            color: theme.palette.white,
        },
    },
    statusBadge: {
        position: 'absolute',
        top: 4,
        right: 4,
        width: 12,
        height: 12,
        borderRadius: '50%',
        backgroundColor: theme.palette.colors.success[300],
        border: `2px solid ${theme.palette.colors.violet[400]}`,
    },
    modal: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        width: '100%',
        height: '100%',
        padding: '20px',
        [theme.breakpoints.down('sm')]: {
            padding: '10px',
        },
    },
}));
const AssistantTALI = () => {
    const classes = useStyles();
    const [openModal, setOpenModal] = React.useState(false);
    const handleModalTALI = (event) => {
        event.stopPropagation();
        setOpenModal(!openModal);
    }
    
    return (
        <>
            <Box className={classes.root}>
                <Fab className={classes.icon} onClick={handleModalTALI} aria-label="chat" id="talisis_assistant_tali_button">
                    {!openModal && <span className={classes.statusBadge} />}
                    {!openModal && <Icon className='ri-cpu-line' />}
                    {openModal && <Icon className='ri-arrow-right-s-line text-white' />}
                </Fab>
            </Box>
            <Modal open={openModal} onClose={() => setOpenModal(false)} disableBackdropClick aria-label="chat">
                <Box className={classes.modal}>
                    <ChatTALI />
                </Box>
            </Modal>
        </>
    );
};

export default AssistantTALI;